export enum LineCapEnum {
  BUTT = 'butt',
  SQUARE = 'square',
  ROUND = 'round',
}
